export const defaultDailyQuests = [
	{ id: "default-daily-quest-1", idBackground: "default-daily-quest-1-backgound" },
	{ id: "default-daily-quest-2", idBackground: "default-daily-quest-2-backgound" },
	{ id: "default-daily-quest-3", idBackground: "default-daily-quest-3-backgound" },
	{ id: "default-daily-quest-4", idBackground: "default-daily-quest-4-backgound" },
];
export const defaultMonthlyQuests = [{ id: "default-montlhy-quest-1", idBackground: "default-montlhy-quest-1-backgound" }];
